/*
 * Отступа снизу здесь НЕТ намеренно — его задаёт страница.
 *
 * ⚠️ Общего числа здесь быть не может: Сводка — 22px (строка 324), Брони — 20px (610), Студия —
 * свой у каждого раздела. (Задачи из этого перечня выпали: там компактная панель без
 * Fraunces-заголовка вовсе, то есть `PageHeader` их не рисует.)
 *
 * ⚠️ Номера строк макета сдвинулись, когда дизайнеры его переработали, — это уже вторая правка
 * ссылок в этом файле. Меняя число, сверяйтесь с файлом, а не с соседним комментарием.
 *
 * Но важнее самого числа то, ЧЬЁ оно. На большинстве экранов заголовок стоит внутри flex-строки,
 * где рядом с ним живут элементы управления (кнопки на Сводке, «Новый сценарий» в Студии), и отступ
 * висит на ЭТОЙ СТРОКЕ, а не на заголовке. То есть это свойство раскладки, а не компонента.
 * Присвоив его себе, PageHeader отобрал у страницы то, что ей принадлежит.
 *
 * Страница задаёт отступ через `className`.
 */
.root {
  /* пусто намеренно — см. комментарий выше */
}

.eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
  margin-bottom: 12px;
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent);
  flex-shrink: 0;
}

.title {
  font-family: 'Fraunces Variable', serif;
  font-weight: 500;
  line-height: 1.05;
  letter-spacing: -0.02em;
  margin: 0;
  font-variation-settings: 'opsz' 120;
}

/* Сводка (макет, строка 329) и Брони (612) — два главных экрана. */
.lg {
  font-size: 34px;
}

/* Разделы Студии, идущие через `StudioSectionFrame`: Платежи (1640), Источники (1658),
   Аудит (1785), Бренд (1886). «Каналы» (1524) и «AI-консьерж» (1681) рисуют шапку сами. */
.md {
  font-size: 32px;
}

/* «Гостевой путь» (649) — единственный экран с этим размером. Заголовок там идёт первым элементом,
   без маркера-категории, и меньший кегль держит его вровень с остальными по оптическому весу. */
.sm {
  font-size: 29px;
}

.description {
  font-size: 14px;
  line-height: 1.5;
  color: var(--ink-2);
  margin: 9px 0 0;
  max-width: 640px;
}

/*
 * У «Гостевого пути» лид тише и уже (макет:650 — 13.5px, `--ink-3`, 540px), и это не случайность:
 * заголовок там идёт первым, без маркера-категории, а сразу под лидом начинается онбординг-чеклист.
 * Более громкий лид спорил бы с ним за первое внимание. На двух главных экранах — 14px/`--ink-2`/640
 * (Сводка 330, Брони 613), и это наш общий случай. Разделы Студии в макете чуть иные — 600–620 при
 * 10px отступа и межстрочном 1.55 (1641, 1659, 1682) — но разница там в пределах пары пикселей,
 * и разводить её отдельным правилом дороже, чем принять; у «Гостевого пути» разница смысловая.
 */
.root[data-size='sm'] .description {
  margin-top: 7px;
  max-width: 540px;
  color: var(--ink-3);
  font-size: 13.5px;
}
